import { UIText3 } from '@cian/ui-kit';
import { IconFunctionalWarningCircle16 } from '@cian/ui-kit-design-tokens/icons';

import { clsx } from 'clsx';
import { type PropsWithChildren, type ReactNode } from 'react';

import styles from './PessimizationOverlay.css';

export type Pessimization = {
  background: 'red' | 'gray' | 'blur';
  text: string;
};

type PessimizationOverlayProps = {
  pessimization?: Pessimization;
};

export function PessimizationOverlay({
  children,
  pessimization,
}: PropsWithChildren<PessimizationOverlayProps>): ReactNode {
  if (!pessimization) {
    return children;
  }

  return (
    <div className={clsx(styles['wrapper'], styles[`wrapper-${pessimization.background}`])} data-testid="pessimization">
      {children}
      <div className={styles['banner']}>
        <IconFunctionalWarningCircle16 color="text-inverted-default" display="block" />
        <UIText3 as="p" color="text-inverted-default" textAlign="center">
          {pessimization.text}
        </UIText3>
      </div>
    </div>
  );
}
